import * as React from 'react'
import * as css from './LogoListScroll.module.css'
import HTag from 'components/common/HTag'
import Img from 'components/common/Img'
import clsx from 'clsx'

const LogoList = ({ logos }) => {
	const ref = React.useRef(null)
	const [$listWidth, set$listWidth] = React.useState('100%')

	React.useEffect(() => {
		set$listWidth(`${ref.current.scrollWidth}px`)
	}, [ref, set$listWidth])

	return (
		<div ref={ref} className={css.logos} style={{ '--list-width': $listWidth }}>
			{logos?.map((logo, key) => (
				<div className="grid h-[60px] w-[100px] place-content-center" key={key}>
					<Img image={logo?.image?.original} alt={logo?.name} />
				</div>
			))}
		</div>
	)
}

export default function LogoListScroll({
	heading,
	centered,
	mainLogo,
	logos,
	rows,
}) {
	return (
		<section
			className="grid gap-y-8 bg-white py-20 sm:gap-y-12"
			style={{ '--rows': rows }}
		>
			<HTag
				className={clsx(
					'technical-lg mx-auto max-w-screen-xl px-4',
					centered && 'text-center',
				)}
				{...heading}
			/>

			{!!mainLogo?.image?.original && (
				<>
					<figure className="text-center">
						<Img image={mainLogo.image?.original} alt={mainLogo.name} />
					</figure>

					<hr className="mx-auto w-20 border-b-2 border-ft-green" />
				</>
			)}

			<figure className="flex overflow-hidden <md:mt-8">
				<LogoList logos={logos} />
				<LogoList logos={logos} />
			</figure>
		</section>
	)
}
